export const TALENT_FILTERS_STORAGE_KEY = "talent_list_filters";
export const TALENT_SELECTED_STORAGE_KEY = "talent_selected";
export const TALENT_SELECT_ALL_STORAGE_KEY = "talent_select_all";
export const TALENT_LIST_URL_STORAGE_KEY = "talent_list_url";
export const TALENT_PAGE_STORAGE_KEY = "talent_list_page";
export const TALENT_DISPLAY_COLUMNS_STORAGE_KEY = "talent_display_columns";
export const TALENT_ADVANCED_FILTERS_STORAGE_KEY = "talent_advanced_filters";
export const TALENT_APPLIED_CONDITION_NAME_STORAGE_KEY = "talent_applied_condition_name";
export const TALENT_APPLIED_CONDITION_ID_STORAGE_KEY = "talent_applied_condition_id";
export const TALENT_DEFAULT_SEEDED_STORAGE_KEY = "talent_default_seeded";

export const HIDE_PERSONAL_INFO_RESUME_MESSAGE = "個人情報を省いた履歴書を出力します。";
